import { Component, Inject, EventEmitter } from '@angular/core';
import { MatSnackBarRef, MAT_SNACK_BAR_DATA } from '@angular/material/snack-bar';

export interface SnackBarMessageData {
  message: string;
}

@Component({
  template: ` <div class="d-flex">
    <span [innerHTML]="errorMessage | translate"></span>
    <button style="margin-left:auto;" mat-icon-button (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </div>`,
})
export class SnackBarMessagesComponent {
  onClose = new EventEmitter<any>();

  errorMessage: string;
  constructor(
    private snackBarRef: MatSnackBarRef<SnackBarMessagesComponent>,
    @Inject(MAT_SNACK_BAR_DATA) data: SnackBarMessageData
  ) {
    if (data != null) {
      this.errorMessage = data.message;
    }
    snackBarRef.afterDismissed().subscribe((val) => {
      this.onClose.emit();
    });
  }

  close() {
    this.snackBarRef.dismiss();
  }
}
